function getData(name,data, default_value = null, enter_array = false){
  if(!data) return default_value;
  if(!name) return data ?? default_value;
  let [p1, ...pl] = name.split('.');
  if(pl){
    if(enter_array && Array.isArray(data[p1])){
      let r = [];
      for (let i = 0; i < data[p1].length; i++) {
        r.push(getData(pl.join("."),data[p1][i],default_value,enter_array));
      }
      return r;
    }
    return getData(pl.join("."),data[p1],default_value,enter_array);
  } else {
    return data[p1] ?? default_value;
  }
}

function compareData(compare, value, value2){
  if(Array.isArray(value2)){
    for(let i of value2){
      if(compareData(compare,value,i)){
        return true;
      }
    }
  }

  value2 = value2?value2.toString():null;
  value  = value?value.toString():null;

  switch(compare){
    case "=": return value2 === value;
    case "<>": return value2 !== value;
    case "!=": return value2 !== value;
    case ">": return parseFloat(value2) > parseFloat(value);
    case "<": return parseFloat(value2) < parseFloat(value);
    case ">=": return parseFloat(value2) >= parseFloat(value);
    case "<=": return parseFloat(value2) <= parseFloat(value);
    case "like": return value.toString().indexOf(value2.toString()) !== -1;
    default: return false;
  }
}

export default class Collection{
  list;
  constructor(list){
    this.list = list;
  }

  clearEmpty(){
    if(Array.isArray(this.list)){
      let aux = [...this.list];
      let aux2 = [];
      for (const iterator of aux) {
        if(!!iterator)aux2.push(iterator);
      }
      this.list = [...aux2];
    }
  }

  first(){
    let l = (Array.isArray(this.list)?this.list:Object.values(this.list));
    return l.length > 0?l[0]:null;
  }

  last(){
    let l = (Array.isArray(this.list)?this.list:Object.values(this.list));
    return l.length > 0?l[l.length-1]:null;
  }

  where(name, compare, value){
    let r = [];
    for (const iterator of (Array.isArray(this.list)?this.list:Object.values(this.list))) {
      let d = getData(name??"", iterator, null, true);
      if(compareData(compare,value,d)){
        r.push(iterator);
      }
    }
    return new Collection(r);
  }

  whereIsNull(name){
    let r = [];
    for (const iterator of (Array.isArray(this.list)?this.list:Object.values(this.list))) {
      let d = getData(name??"", iterator, null, true);
      if(d === null){
        r.push(iterator);
      }
    }
    return new Collection(r);
  }

  whereIsNotNull(name){
    let r = [];
    for (const iterator of (Array.isArray(this.list)?this.list:Object.values(this.list))) {
      let d = getData(name??"", iterator, null, true);
      if(d !== null){
        r.push(iterator);
      }
    }
    return new Collection(r);
  }

  whereIn(name, values){
    let r = [];
    for (const iterator of (Array.isArray(this.list)?this.list:Object.values(this.list))) {
      let d = getData(name??"", iterator, null, true);
      for (const value of values) {
        if(compareData("=",value,d)){
          r.push(iterator);
        }
      }
    }
    return new Collection(r);
  }

  isEmpty(){
    return (Array.isArray(this.list)?this.list:Object.values(this.list)).length === 0;
  }

  map(callback){
    let list = [...(Array.isArray(this.list)?this.list:Object.values(this.list))];
    let keys = (Array.isArray(this.list)?[]:Object.keys(this.list))
    let r = {};
    if(keys.length === 0){
      r = [];
    }
    for (let i = 0; i < list.length; i++) {
      const iterator = list[i];
      let key = keys?keys[i]:i;
      let key2 = key;
      try {
        key = JSON.parse(key.toString());
      } catch (error) {}
      if(Array.isArray(r)) {
        r.push(callback(iterator, key));
      } else {
        r[key2] = callback(iterator, key);
      }
    }
    
    return new Collection(r);
  }

  sum(name){
    let total = 0;
    for (const iterator of (Array.isArray(this.list)?this.list:Object.values(this.list))) {
      total += parseFloat(getData(name??"", iterator, 0));
    }
    return total;
  }

  pluck(name){
    let r = [];
    for (const iterator of (Array.isArray(this.list)?this.list:Object.values(this.list))) {
      r.push(getData(name??"", iterator))
    }
    return new Collection(r);
  }

  unique(name){
    let r = [];
    let s = [];
    for (const iterator of (Array.isArray(this.list)?this.list:Object.values(this.list))) {
      let vs = JSON.stringify(getData(name??"", iterator));
      if(s.indexOf(vs) === -1){
        r.push(iterator)
        s.push(vs)
      }
    }
    return new Collection(r);
  }

  max(name){
    let r = null;
    let c = Number.MIN_SAFE_INTEGER;
    for (const iterator of (Array.isArray(this.list)?this.list:Object.values(this.list))) {
      let v = getData(name??"", iterator, 0);
      if(c < v){
        r = iterator;
      }
    }
    return r;
  }

  min(name){
    let r = null;
    let c = Number.MAX_SAFE_INTEGER;
    for (const iterator of (Array.isArray(this.list)?this.list:Object.values(this.list))) {
      let v = getData(name??"", iterator, 0);
      if(c > v){
        r = iterator;
      }
    }
    return r;
  }

  group(name, join){
    if(name && name.indexOf(";") !== -1){
      let [n, ...names] = name.split(";");
      let r = this.group(n, join);
      if(names.length > 0){
        r = r.map((l)=>{
          return collect(l).group(names.join(";"), join);
        })
      }
      return r;
    } else {
      if(name){
        let n = name.split(',');
        if(n.length>1){
          let r = {};
          for (const iterator of (Array.isArray(this.list)?this.list:Object.values(this.list))) {
            let d = {};
            for (let i = 0; i < n.length; i++) {
              d[n[i]] = getData(n[i], iterator);
            }
            let g = JSON.stringify(d);
  
            if(!r[g]){
              r[g] = [];
            }
            r[g].push(iterator);
          }
          return new Collection(r);
        }
      }
      let r = {};
      for (const iterator of (Array.isArray(this.list)?this.list:Object.values(this.list))) {
        let g = JSON.stringify(getData(name??"", iterator));
        if(!r[g]){
          r[g] = [];
        }
        r[g].push(iterator);
      }
      if(join){
        return new Collection(collect(r).map((l,n)=>{
          let a = {list:l};
          a[join] = n;
          return a;
        }).toArray());
      }
      return new Collection(r);
    }
  }

  toArray(){
    return [...(Array.isArray(this.list)?this.list:Object.values(this.list))];
  }

  toObject(){
    if (Array.isArray(this.list)) {
      return this.list;
    }
    let r = {};
    let keys = Object.keys(this.list);
    for (const key of keys) {
      let aux = this.list[key];
      if(aux instanceof Collection) {
        r[key] = aux.toObject();
      } else {
        r[key] = aux;
      }
    }
    return r;
  }

  count(){
    return (Array.isArray(this.list)?this.list:Object.values(this.list)).length;
  }
  
  sortBy(name){
    let l = [...(Array.isArray(this.list)?this.list:Object.values(this.list))];
    for (let i = 0; i < l.length; i++) {
      for (let j = i+1; j < l.length; j++) {
        if(getData(name??"", l[i], 0) > getData(name??"", l[j], 0)){
          let aux = l[i];
          l[i] = l[j];
          l[j] = aux;
        }
      }
    }
    return new Collection(l);
  }

  sortByDesc(name){
    let l = [...(Array.isArray(this.list)?this.list:Object.values(this.list))];
    for (let i = 0; i < l.length; i++) {
      for (let j = i+1; j < l.length; j++) {
        if(getData(name??"", l[i], 0) < getData(name??"", l[j], 0)){
          let aux = l[i];
          l[i] = l[j];
          l[j] = aux;
        }
      }
    }
    return new Collection(l);
  }

  shuffle(){
    let l = [...(Array.isArray(this.list)?this.list:Object.values(this.list))];
    for (let i = 0; i < l.length; i++) {
      let j = Math.floor(Math.random() * l.length)
      let aux = l[i];
      l[i] = l[j];
      l[j] = aux;
    }
    return new Collection(l);
  }

  take(n, n2){
    let l = [...(Array.isArray(this.list)?this.list:Object.values(this.list))];
    let r = [];
    if(!n2){
      for (let i = 0; i < Math.min(l.length,n); i++) {
        r.push(l[i]);
      }
    } else {
      for (let i = Math.max(0,n); i < Math.min(l.length,n2); i++) {
        r.push(l[i]);
      }
    }
    return new Collection(r);
  }

  reduceList(name){
    let list = this.pluck(name).toArray();
    
    let aux = [];
    for (let i = 0; i < list.length; i++) {
      let v = list[i];
      if(Array.isArray(v)){
        aux = [...aux, ...v];
      } else {
        aux.push(v);
      }
    }
    return new Collection(aux);
  }

  join(c){
    return [...(Array.isArray(this.list)?this.list:Object.values(this.list))].join(c);
  }

  piece(n){
    let new_list = [];
    let return_list = [];
    let old_list = [...(Array.isArray(this.list)?this.list:Object.values(this.list))];
    for (let index = 0; index < old_list.length; index++) {
      if(index < n){
        return_list.push(old_list[index]);
      } else {
        new_list.push(old_list[index]);
      }
    }
    this.list = new_list;
    return return_list;
  }

  forEach(callback){
    let list = [...(Array.isArray(this.list)?this.list:Object.values(this.list))];
    let keys = (Array.isArray(this.list)?[]:Object.keys(this.list))
    let r = {};
    if(keys.length === 0){
      r = [];
    }
    for (let i = 0; i < list.length; i++) {
      const iterator = list[i];
      let key = keys?keys[i]:i;
      try {
        key = JSON.parse(key.toString());
      } catch (error) {}
      callback(iterator, key);
    }
  }
}

export function collect(list){
  return new Collection(list);
}